// Example: Override default Add to Cart behavior
document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
  form.addEventListener('submit', function(e) {
    const formData = new FormData(form);
    const variantId = formData.get('id');

    // Check if the variant ID is the one we want to trigger upsell
    if (true) { // Replace with actual variant ID
      e.preventDefault();

      // Show your popup/modal/section with "Yes", "No", "Chronopost"
      showUpsellOptions(variantId, formData);
    }
  });
});

function showUpsellOptions(variantId, originalFormData) {
  // Display your custom popup UI
  const modal = document.getElementById('upsell-popup');
  modal.style.display = 'block';

  // Button click handlers
  document.getElementById('upsell-yes').onclick = () => {
    // Add both items to cart
    addItemToCart(variantId);
    addItemToCart('987654321'); // Variant ID of extra item
  };
  document.getElementById('upsell-no').onclick = () => {
    // Just add original item
    addItemToCart(variantId);
  };
  document.getElementById('upsell-chrono').onclick = () => {
    // Just add Chronopost (or do something else)
    addItemToCart('222222222'); // Variant ID of Chronopost item
  };
}

function addItemToCart(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({id: variantId, quantity: 1})
  })
  .then(response => response.json())
  .then(data => {
    // Optionally redirect or update cart UI
    console.log('Added to cart', data);
    window.location.href = '/cart'; // Or update drawer
  });
}
